import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTenant } from '@/contexts/TenantContext';

export type UserRole = 'owner' | 'admin' | 'member';

interface RoleGuardProps {
  children: React.ReactNode;
  allowedRoles: UserRole[];
}

export const RoleGuard: React.FC<RoleGuardProps> = ({ children, allowedRoles }) => {
  const { role, loading } = useTenant();

  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Se não tem role, não devia estar no painel de admin. Mas se estiver, evitar loop infinito
  if (!role) {
    if (location.pathname === '/dashboard') {
      // Já está no dashboard, renderiza normal para não entrar em loop, ou redireciona pra fora
      // Melhor redirecionar pra home (pública) se não tem role, pois a pessoa não tem tenant
      return <Navigate to="/" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  if (!allowedRoles.includes(role as UserRole)) {
    // Redirecionar para dashboard caso não tenha acesso
    if (location.pathname === '/dashboard') {
      return <Navigate to="/" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
